import React, { useState, useEffect } from 'react';
import {
  Site, DeviceData, DeviceProfile
} from "../../model/model";

interface IProps {
  site: Site;
  deviceData: DeviceData;
  deviceProfile?: DeviceProfile;
}

const pluginModules = import.meta.glob('../../plug/devconf/*/Plugin.tsx', { eager: false });
console.log('ConfigDevice: available plugin modules:', Object.keys(pluginModules));

function ConfigDevice(props: IProps) {
  const [Plugin, setPlugin] = useState<React.ComponentType<any> | null>(null);

  useEffect(() => {
    if (!props.deviceData.devProfileId) {
      console.log('ConfigDevice: no devProfileId');
      setPlugin(null);
      return;
    }

    const pluginPath = `../../plug/devconf/${props.deviceData.devProfileId}/Plugin.tsx`;
    console.log('ConfigDevice: looking for plugin at:', pluginPath);
    console.log('ConfigDevice: available modules:', Object.keys(pluginModules));
    const moduleLoader = pluginModules[pluginPath];
    console.log('ConfigDevice: moduleLoader found:', !!moduleLoader);
    if (!moduleLoader) {
      setPlugin(null);
      return;
    }

    moduleLoader().then((module: any) => {
      console.log('ConfigDevice: plugin loaded successfully');
      setPlugin(() => module.default);
    }).catch((err) => {
      console.log('ConfigDevice: plugin load failed:', err);
      setPlugin(null);
    });
  }, [props.deviceData.devProfileId]);

  if (!Plugin) {
    return null;
  }

  return <Plugin site={props.site} deviceData={props.deviceData} deviceProfile={props.deviceProfile}/>;
}
export default ConfigDevice;
